import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ca', name: 'Català', flag: '🏴' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();
  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  const handleChange = (value) => {
    i18n.changeLanguage(value);
  };

  if (variant === 'minimal') {
    return (
      <div className="flex items-center gap-1">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleChange(lang.code)}
            className={`px-2 py-1 text-xs font-medium rounded transition-colors ${
              i18n.language === lang.code
                ? 'bg-white/10 text-white'
                : 'text-slate-400 hover:text-white'
            }`}
            data-testid={`lang-switch-${lang.code}`}
          >
            {lang.code.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  return (
    <Select value={i18n.language} onValueChange={handleChange}>
      <SelectTrigger 
        className="w-auto min-w-[120px] h-9 bg-transparent border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white text-sm"
        data-testid="language-switcher"
      >
        <Globe className="w-4 h-4 mr-2 opacity-70" />
        <SelectValue>
          {currentLang.flag} {currentLang.name}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-slate-900 border-slate-700">
        {languages.map((lang) => (
          <SelectItem 
            key={lang.code} 
            value={lang.code}
            className="text-slate-300 hover:bg-slate-800 hover:text-white focus:bg-slate-800 focus:text-white cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
